import { render } from "./IssuanceFinished.vue?vue&type=template&id=0fe1acc0&scoped=true"
import script from "./IssuanceFinished.vue?vue&type=script&lang=js"
export * from "./IssuanceFinished.vue?vue&type=script&lang=js"

import "./IssuanceFinished.vue?vue&type=style&index=0&id=0fe1acc0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe1acc0"]])

export default __exports__